import { SelectOption } from '@globaleris/ui.library'
import { Contrato } from '../../..'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ContractTypes } from '../../enums/contractTypes'

export class ApiContracts {
  FetchOptions = async (
    subject: number,
    balanceZone: number,
    contractType?: ContractTypes
  ): Promise<SelectOption[]> => {
    return await AxiosInstance.post(
      `${getAppConfigurationValue(
        AppConfigurationKey.ApiUrlSuffixPioneer
      )}/api/contracts/FetchSelectOptions`,
      {
        subject: subject,
        contractType: contractType,
        balanceZone: balanceZone
      }
    ).then(response => {
      return response.data
    })
  }

  FetchContractsToTrades = async (
    subject: number,
    contractType: ContractTypes,
    balanceZone: number
  ): Promise<Contrato[]> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
    //let filter = `zonabalance eq '${balanceZone}' and sujeto/id eq ${subject} and tipoContrato eq '${contractType}'`;
    return await AxiosInstance.post(`${apiSuffixUrl}/api/contracts/FetchContractsToTrade`, {
      subject: subject,
      contractType: contractType,
      balanceZone: balanceZone
    }).then(response => {
      return response.data
    })
  }
}

export const fetchContratsBySubject = async (subjectID: number) => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Contracts/BySubject/${subjectID}`)
    .then(response => response.data)
}
